<template>
  <component
    :is="tag"
    class="app-container"
    :class="containerClasses"
    v-bind="$attrs"
  >
    <slot />
  </component>
</template>

<script>
/**
 * AppContainer — wrapper de layout con ancho configurable.
 *
 * Reemplazo gradual de b-container / .container* / .container-fluid.
 * Reglas (spec 005):
 *  - HTML plano (sin pug), CSS propio.
 *  - Sin tags b-* ni clases Bootstrap como dependencia.
 *  - inheritAttrs: false + v-bind="$attrs" al root.
 *
 * Props:
 *  - fluid: ancho completo (100%). Default false.
 *  - tag: elemento root. Default 'div'.
 *  - padding: aplica padding horizontal interno. Default true.
 *  - centered: aplica max-width y margin auto cuando NO es fluid. Default true.
 */
export default {
  name: 'AppContainer',
  inheritAttrs: false,
  props: {
    fluid: { type: Boolean, default: false },
    tag: { type: String, default: 'div' },
    padding: { type: Boolean, default: true },
    centered: { type: Boolean, default: true }
  },
  computed: {
    containerClasses() {
      return {
        'app-container--fluid': this.fluid,
        'app-container--padded': this.padding,
        'app-container--centered': this.centered && !this.fluid
      }
    }
  }
}
</script>

<style scoped>
.app-container {
  width: 100%;
  box-sizing: border-box;
}

.app-container--padded {
  padding-left: 16px;
  padding-right: 16px;
}

.app-container--centered {
  max-width: 1540px;
  margin-left: auto;
  margin-right: auto;
}

.app-container--fluid {
  width: 100%;
}
</style>